import { Component, OnInit } from '@angular/core';
import { Column } from 'exceljs';
import { AsianPaintsGlobetrotterService } from './asian-paints-globetrotter.service';
import { PlayerListColumn } from '../shared/player-list/player-list-column';

@Component({
  selector: 'app-asian-paints-globetrotter',
  templateUrl: './asian-paints-globetrotter.component.html',
  styleUrls: ['./asian-paints-globetrotter.component.scss'],
})
export class AsianPaintsGlobetrotterComponent implements OnInit {
  currentTab = 'Scientific Rigour';
  scientificRigourColumns: PlayerListColumn[] = [
    {
      name: 'Employee Id',
      key: 'employeeId',
    },
    {
      name: 'Name',
      key: 'name',
    },
    {
      name: 'Highest Score',
      key: 'highestScore',
      type: 'number',
    },
    {
      name: 'Completed Date',
      key: 'completedAt',
      type: 'string',
      formatter: '',
    },
  ];
  scientificRigourPlayers$ = this._asianPaintsService.scientificRigourPlayers$;

  scientificRigourWorksheetColumns = [
    { header: 'Employee Id', key: 'employeeId', width: 50 } as Column,
    { header: 'Name', key: 'name', width: 50 } as Column,
    {
      header: 'Highest Score',
      key: 'highestScore',
      width: 15,
      alignment: { horizontal: 'center' },
    } as Column,
    { header: 'Completed Date', key: 'completedAt', width: 15 } as Column,
  ];

  constructor(private _asianPaintsService: AsianPaintsGlobetrotterService) {
    this._asianPaintsService.fetchScientificRigourPlayers();
  }

  ngOnInit(): void {
    console.log('Loaded');
  }

  tabChanged(event: any): void {
    console.log('Event: ', event);
  }
}
